export default __webpack_public_path__ + "static/media/tennis-gold-featured.8eae7185.png";